
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7GE7t", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $4qT1X = parcelRequire("4qT1X");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $5b4k9 = parcelRequire("5b4k9");


var $3Tbc2 = parcelRequire("3Tbc2");


var $56k0U = parcelRequire("56k0U");


var $3g9yJ = parcelRequire("3g9yJ");

const $018bee3f0d224b60$export$4d8c59e1d2af415b = (0, $5b4k9.SEARCH_COMBINED_CONFIG_CACHE_KEY);
const $018bee3f0d224b60$export$520f811efd7d75bb = (0, $5b4k9.SEARCH_COMBINED_CONFIG_BARE_CACHE_KEY);
// Adapter-backed cache (host StorageManager → account-namespaced key
// `atlassian.<accountId>.frontend.search-combined-config`, mirrored into
// getRemoteLocalStorage for SSR).
//
// Used by the UNTOUCHED legacy FG-off path (`updateCombinedConfigCacheEntry`,
// `getCombinedSearchConfig` legacy branch) and by the SSR-fill
// (`seedCombinedConfigCacheEntry` via `fillSsrCombinedConfigCache`), which both
// rely on the AAID-scoped key.
const { refreshOnAccessDecorator: $018bee3f0d224b60$var$refreshOnAccessDecoratorCombined, update: $018bee3f0d224b60$var$updateCombinedCache, seed: $018bee3f0d224b60$var$seedCombinedCache } = (0, $jnPv4.promiseCache)({
    name: $018bee3f0d224b60$export$4d8c59e1d2af415b,
    shouldUseStorageAdapter: true
});
// Bare-key runtime cache (client-only, NOT account-namespaced, NOT SSR-visible).
// Writes the literal `frontend.search-combined-config` localStorage key (distinct
// from the account-namespaced adapter key above).
//
// Used ONLY by the FG-on (`rovo_fps_use_rovo_config`) `useRovoConfig` runtime
// writers — `getCombinedSearchConfig` (FG-on branch), `seedBase…`, `updateBase…`.
const { refreshOnAccessDecorator: $018bee3f0d224b60$var$refreshOnAccessDecoratorBaseRuntime, update: $018bee3f0d224b60$var$updateBaseRuntimeCache, seed: $018bee3f0d224b60$var$seedBaseRuntimeCache } = (0, $jnPv4.promiseCache)({
    name: $018bee3f0d224b60$export$520f811efd7d75bb,
    shouldUseStorageAdapter: false
});
const $018bee3f0d224b60$export$c066f72d16c9afa5 = (userId, cloudId, updater)=>{
    const key = (0, $56k0U.generateCombinedConfigHash)(userId, cloudId);
    return $018bee3f0d224b60$var$updateCombinedCache(key.toString(), updater);
};
const $018bee3f0d224b60$export$34fe4a744c051b23 = ({ userId: userId, cloudId: cloudId, config: config, expiration: expiration })=>{
    const key = (0, $56k0U.generateCombinedConfigHash)(userId || '', cloudId);
    return $018bee3f0d224b60$var$seedCombinedCache(key.toString(), config, expiration);
};
/**
 * The inner cache key for the **base** combined-config runtime entry used by
 * `useRovoConfig`. Keyed on a hash of the `cloudId` only — no `userId` — so the
 * entry is per-site but not per-account (the localStorage key prefix already
 * scopes per-account).
 */ const $018bee3f0d224b60$var$getBaseCombinedConfigCacheKey = (cloudId)=>(0, $2qzBQ.generateHash)(cloudId).toString();
/**
 * Resolve the runtime combined-config cache key, gated by the
 * `rovo_fps_use_rovo_config` feature gate.
 *
 * - **FG ON** (the canonical `useRovoConfig` path): a hash of the `cloudId`
 *   only — no `userId` in the inner key.
 * - **FG OFF** (the legacy `useFetchConfigLegacy` path): the historical
 *   `getCombinedConfigHash(userId, cloudId)` inner key, preserving the
 *   pre-RAOC cache behaviour byte-for-byte.
 */ const $018bee3f0d224b60$var$resolveRuntimeCombinedConfigCacheKey = (userId, cloudId)=>(0, $dh538.fg)('rovo_fps_use_rovo_config') ? $018bee3f0d224b60$var$getBaseCombinedConfigCacheKey(cloudId || '') : (0, $56k0U.generateCombinedConfigHash)(userId || '', cloudId || '').toString();
const $018bee3f0d224b60$export$707f15bd9a09224d = (cloudId, updater)=>$018bee3f0d224b60$var$updateBaseRuntimeCache($018bee3f0d224b60$var$getBaseCombinedConfigCacheKey(cloudId), updater);
const $018bee3f0d224b60$export$5f90db2f52f87370 = ({ cloudId: cloudId, config: config, expiration: expiration })=>$018bee3f0d224b60$var$seedBaseRuntimeCache($018bee3f0d224b60$var$getBaseCombinedConfigCacheKey(cloudId), config, expiration);
const $018bee3f0d224b60$export$d6a374b1da3ff3ff = async ({ accountId: accountId, cloudId: cloudId, config: config, expiration: expiration })=>{
    if (!accountId) return false;
    await $018bee3f0d224b60$export$34fe4a744c051b23({
        userId: accountId,
        cloudId: cloudId,
        config: config,
        expiration: expiration
    });
    return true;
};
const $018bee3f0d224b60$export$8993626c2cc6d711 = async ({ cloudId: cloudId, userId: userId, aggAbsoluteUrl: aggAbsoluteUrl, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired, networkCallbacks: networkCallbacks, headers: headers })=>{
    // FG-on (`useRovoConfig`): bare-key runtime cache (client-only, no AAID).
    // FG-off (legacy): the original adapter-backed cache — untouched.
    const refreshOnAccess = (0, $dh538.fg)('rovo_fps_use_rovo_config') ? $018bee3f0d224b60$var$refreshOnAccessDecoratorBaseRuntime : $018bee3f0d224b60$var$refreshOnAccessDecoratorCombined;
    return refreshOnAccess({
        key: $018bee3f0d224b60$var$resolveRuntimeCombinedConfigCacheKey(userId, cloudId),
        supplier: ()=>{
            const combinedConfigPromise = (0, $4qT1X.fetchAgg)({
                graphQuery: (0, $3g9yJ.getSearchConfigQuery)(),
                variables: {
                    cloudId: cloudId
                },
                operationName: (0, $3g9yJ.GQL_OPERATION_NAME),
                aggAbsoluteUrl: aggAbsoluteUrl,
                headers: headers
            }).then((response)=>{
                const hasErrors = response.errors?.some((error)=>error);
                if (hasErrors) {
                    const errorsAsString = response.errors?.map((error)=>error.message).join(', ');
                    throw new Error(`Search combined config response had errors: ${errorsAsString}`);
                }
                const configuration = response.data?.search?.configuration;
                if (!configuration) throw new Error('Search combined config response missing configuration.');
                return configuration;
            });
            const degrader = new (0, $3Tbc2.DegradablePromise)(combinedConfigPromise, degradationCallback);
            return degrader.promise();
        },
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true
    });
};
module.exports["SEARCH_COMBINED_CONFIG"] = $018bee3f0d224b60$export$4d8c59e1d2af415b;
module.exports["updateCombinedConfigCacheEntry"] = $018bee3f0d224b60$export$c066f72d16c9afa5;
module.exports["seedCombinedConfigCacheEntry"] = $018bee3f0d224b60$export$34fe4a744c051b23;
module.exports["updateBaseCombinedConfigCacheEntry"] = $018bee3f0d224b60$export$707f15bd9a09224d;
module.exports["seedBaseCombinedConfigCacheEntry"] = $018bee3f0d224b60$export$5f90db2f52f87370;
module.exports["fillSsrCombinedConfigCache"] = $018bee3f0d224b60$export$d6a374b1da3ff3ff;
module.exports["getCombinedSearchConfig"] = $018bee3f0d224b60$export$8993626c2cc6d711;

});

parcelRegister("56k0U", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");

const $111f7ad2df2741e2$export$4f967acd0a387888 = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`${userId}${cloudId}`);
module.exports["generateCombinedConfigHash"] = $111f7ad2df2741e2$export$4f967acd0a387888;

});

parcelRegister("3g9yJ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


const $2e71f19aacd56888$export$c5dfc39e7764783c = 'searchCombinedConfig';
const $2e71f19aacd56888$export$1693aa41d49ec148 = ()=>`
query ${$2e71f19aacd56888$export$c5dfc39e7764783c}($cloudId: ID!) {
  search {
      configuration(cloudId: $cloudId) {
        firstPartyProducts {
          name
        }
        thirdPartyProducts {
          name
          outboundAuthUrl
          isUserOAuthed
          providerId
          integrationARI
          workspaceName
          workspaceUrl
          datasourceId
          connectionId
          connectorSyncType
          isImpersonationAuthEnabled
          connectorCreatedAt
          ${(0, $dh538.fg)('rovo_cas_use_rovo_config') ? 'connectedAt' : ''}
          lightIcon
          entityTypes
          environmentType
        }
        intercomHmac
        siteMetadata {
          isRovoEnabled
          isJiraIssueIndexed
          applicationMode
          siteName
          orgId
          productEdition
          productInfo {
            name
            dataRegion
          }
        }
    }
  }
}`;
module.exports["GQL_OPERATION_NAME"] = $2e71f19aacd56888$export$c5dfc39e7764783c;
module.exports["getSearchConfigQuery"] = $2e71f19aacd56888$export$1693aa41d49ec148;

});

parcelRegister("7C1EY", function(module, exports) {
/**
 * First-party product configurations.
 * These are the Atlassian 1P products with their display metadata (icons, display names).
 */ 
var $lAFHW = parcelRequire("lAFHW");

var $4Nwes = parcelRequire("4Nwes");


var $gpcGZ = parcelRequire("gpcGZ");


var $d9lRg = parcelRequire("d9lRg");


var $kLAeC = parcelRequire("kLAeC");


var $exbtu = parcelRequire("exbtu");


var $adt6z = parcelRequire("adt6z");


var $9giCm = parcelRequire("9giCm");


var $dIrQT = parcelRequire("dIrQT");


var $b0Zp3 = parcelRequire("b0Zp3");


var $lw0p3 = parcelRequire("lw0p3");


var $hPjNv = parcelRequire("hPjNv");


var $fj6km = parcelRequire("fj6km");


var $A4T5q = parcelRequire("A4T5q");


var $1ubQ4 = parcelRequire("1ubQ4");


var $khPyY = parcelRequire("khPyY");

const $9db73380f92dcfeb$export$3e4929b42b34f3a8 = {
    [(0, $gpcGZ.ProductKeys1P).Confluence]: {
        displayName: 'Confluence',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.ConfluenceIcon), 'Confluence'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $A4T5q.ConfluenceSearchResultIcon), 'Confluence', 'large')
    },
    [(0, $gpcGZ.ProductKeys1P).Atlas]: {
        displayName: 'Home',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $4Nwes.AtlassianIcon), 'Home'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $A4T5q.AtlasSearchResultIcon), 'Home', 'large')
    },
    [(0, $gpcGZ.ProductKeys1P).Jira]: {
        displayName: 'Jira',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.JiraIcon), 'Jira'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $1ubQ4.JiraSearchResultIcon), 'Jira', 'large')
    },
    [(0, $gpcGZ.ProductKeys1P).JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.JiraProductDiscoveryIcon), 'Jira Product Discovery'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $A4T5q.JiraProductDiscoverySearchResultIcon), 'Jira Product Discovery', 'large')
    },
    [(0, $gpcGZ.ProductKeys1P).JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.JiraServiceManagementIcon), 'Jira Service Management'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $khPyY.JiraServiceManagementSearchResultIcon), 'Jira Service Management', 'large')
    },
    [(0, $gpcGZ.ProductKeys1P).Bitbucket]: {
        displayName: 'Bitbucket',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.BitbucketIcon), 'Bitbucket'),
        // Bitbucket uses the same icon for search results
        searchResultIcon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.BitbucketIcon), 'Bitbucket')
    },
    [(0, $gpcGZ.ProductKeys1P).Trello]: {
        displayName: 'Trello',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.TrelloIcon), 'Trello'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $A4T5q.TrelloSearchResultIcon), 'Trello', 'large')
    },
    [(0, $gpcGZ.ProductKeys1P).Compass]: {
        displayName: 'Compass',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.CompassIcon), 'Compass'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $A4T5q.CompassSearchResultIcon), 'Compass', 'large')
    },
    [(0, $gpcGZ.ProductKeys1P).Focus]: {
        displayName: 'Focus',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.FocusIcon), 'Focus'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $A4T5q.FocusSearchResultIcon), 'Focus', 'large')
    },
    [(0, $gpcGZ.ProductKeys1P).Assets]: {
        displayName: 'Assets',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.AssetsIcon), 'Assets'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $A4T5q.AssetsSearchResultIcon), 'Assets', 'large')
    },
    [(0, $gpcGZ.ProductKeys1P).Talent]: {
        displayName: 'Talent',
        icon: (0, $fj6km.RovoLogoFromLogo)((0, $lAFHW.TalentIcon), 'Talent'),
        searchResultIcon: (0, $fj6km.RovoLogoFromSVG)((0, $A4T5q.TalentSearchResultIcon), 'Talent', 'large')
    }
};
const $9db73380f92dcfeb$export$88aff1c9a685343e = [
    (0, $gpcGZ.ProductKeys1P).Confluence,
    (0, $gpcGZ.ProductKeys1P).Jira,
    (0, $gpcGZ.ProductKeys1P).JiraProductDiscovery,
    (0, $gpcGZ.ProductKeys1P).JiraServiceManagement,
    (0, $gpcGZ.ProductKeys1P).Atlas,
    (0, $gpcGZ.ProductKeys1P).Trello,
    (0, $gpcGZ.ProductKeys1P).Bitbucket,
    (0, $gpcGZ.ProductKeys1P).Compass,
    (0, $gpcGZ.ProductKeys1P).Focus,
    (0, $gpcGZ.ProductKeys1P).Assets,
    (0, $gpcGZ.ProductKeys1P).Talent
];
const $9db73380f92dcfeb$export$633a31c0b66df80f = (productKey)=>{
    return $9db73380f92dcfeb$export$3e4929b42b34f3a8[productKey];
};
const $9db73380f92dcfeb$export$6351cb1baf5bc02f = new Map([
    [
        (0, $gpcGZ.ProductKeys1P).Confluence,
        {
            ...$9db73380f92dcfeb$export$3e4929b42b34f3a8[(0, $gpcGZ.ProductKeys1P).Confluence],
            entities: (0, $9giCm.DEFAULT_CONFLUENCE_ENTITY_ATI)
        }
    ],
    [
        (0, $gpcGZ.ProductKeys1P).Jira,
        {
            ...$9db73380f92dcfeb$export$3e4929b42b34f3a8[(0, $gpcGZ.ProductKeys1P).Jira],
            entities: (0, $b0Zp3.DEFAULT_JIRA_ENTITY_ATI)
        }
    ],
    [
        (0, $gpcGZ.ProductKeys1P).Atlas,
        {
            ...$9db73380f92dcfeb$export$3e4929b42b34f3a8[(0, $gpcGZ.ProductKeys1P).Atlas],
            entities: (0, $kLAeC.DEFAULT_ATLAS_ENTITY_ATI)
        }
    ],
    [
        (0, $gpcGZ.ProductKeys1P).Compass,
        {
            ...$9db73380f92dcfeb$export$3e4929b42b34f3a8[(0, $gpcGZ.ProductKeys1P).Compass],
            entities: (0, $adt6z.DEFAULT_COMPASS_ENTITY_ATI)
        }
    ],
    [
        (0, $gpcGZ.ProductKeys1P).Trello,
        {
            ...$9db73380f92dcfeb$export$3e4929b42b34f3a8[(0, $gpcGZ.ProductKeys1P).Trello],
            entities: (0, $hPjNv.DEFAULT_TRELLO_ENTITY_ATI)
        }
    ],
    [
        (0, $gpcGZ.ProductKeys1P).Bitbucket,
        {
            ...$9db73380f92dcfeb$export$3e4929b42b34f3a8[(0, $gpcGZ.ProductKeys1P).Bitbucket],
            entities: (0, $exbtu.DEFAULT_BITBUCKET_ENTITY_ATI)
        }
    ],
    [
        (0, $gpcGZ.ProductKeys1P).Assets,
        {
            ...$9db73380f92dcfeb$export$3e4929b42b34f3a8[(0, $gpcGZ.ProductKeys1P).Assets],
            entities: (0, $d9lRg.DEFAULT_ASSETS_ENTITY_ATI)
        }
    ],
    [
        (0, $gpcGZ.ProductKeys1P).Talent,
        {
            ...$9db73380f92dcfeb$export$3e4929b42b34f3a8[(0, $gpcGZ.ProductKeys1P).Talent],
            entities: (0, $lw0p3.DEFAULT_TALENT_ENTITY_ATI)
        }
    ],
    [
        (0, $gpcGZ.ProductKeys1P).Focus,
        {
            ...$9db73380f92dcfeb$export$3e4929b42b34f3a8[(0, $gpcGZ.ProductKeys1P).Focus],
            entities: (0, $dIrQT.DEFAULT_FOCUS_ENTITY_ATI)
        }
    ]
]);
module.exports["FirstPartyConfigs"] = $9db73380f92dcfeb$export$3e4929b42b34f3a8;
module.exports["ProductsOrder1P"] = $9db73380f92dcfeb$export$88aff1c9a685343e;

});

parcelRegister("d9lRg", function(module, exports) {
/**
 * Default entity ATIs for Assets/CMDB (1P).
 */ const $86fd773ddf0f5d73$export$9303a82ed1def835 = [
    'ati:cloud:cmdb:object',
    'ati:cloud:cmdb:schema',
    'ati:cloud:cmdb:type'
];
module.exports["DEFAULT_ASSETS_ENTITY_ATI"] = $86fd773ddf0f5d73$export$9303a82ed1def835;

});

parcelRegister("kLAeC", function(module, exports) {
/**
 * Default entity ATIs for Atlas/Townsquare (1P).
 */ const $941404d3a622bcd2$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag',
    'ati:cloud:townsquare:question',
    'ati:cloud:townsquare:learning'
];
module.exports["DEFAULT_ATLAS_ENTITY_ATI"] = $941404d3a622bcd2$export$c87d62ed9387fa60;

});

parcelRegister("exbtu", function(module, exports) {
/**
 * Default entity ATIs for Bitbucket (1P).
 * Combines devinfo pull request and repository ATIs.
 */ 
var $aWEgY = parcelRequire("aWEgY");


var $1xTLA = parcelRequire("1xTLA");

const $5ca5743b72c3a911$export$bbc68bbdfb2251e1 = [
    ...(0, $aWEgY.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
    ...(0, $1xTLA.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI)
];
module.exports["DEFAULT_BITBUCKET_ENTITY_ATI"] = $5ca5743b72c3a911$export$bbc68bbdfb2251e1;

});

parcelRegister("adt6z", function(module, exports) {
/**
 * Default entity ATIs for Compass (1P).
 */ const $fa11b371739e497c$export$7e1741905a27fa1c = [
    'ati:cloud:compass:component'
];
module.exports["DEFAULT_COMPASS_ENTITY_ATI"] = $fa11b371739e497c$export$7e1741905a27fa1c;

});

parcelRegister("9giCm", function(module, exports) {
/**
 * Default entity ATIs for Confluence (1P).
 *
 * Intentionally excludes:
 * - `calendar` / `space-calendar` — handled via team-calendars plugin ATIs separately
 * - Legacy plugin ATIs (confluence.com.atlassian.confluence.extra.team-calendars:*, confluence.ac:*) — handled separately
 */ const $06436b7348994172$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:folder',
    'ati:cloud:confluence:slide',
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:answer',
    'ati:cloud:confluence:question'
];
module.exports["DEFAULT_CONFLUENCE_ENTITY_ATI"] = $06436b7348994172$export$c07a1c127052b557;

});

parcelRegister("dIrQT", function(module, exports) {
/**
 * Default entity ATIs for Focus/Mercury (1P).
 */ const $b32e9626afb6eb73$export$e45b6700dc30d17 = [
    'ati:cloud:mercury:focus-area',
    'ati:cloud:mercury:focus-area-status-update'
];
module.exports["DEFAULT_FOCUS_ENTITY_ATI"] = $b32e9626afb6eb73$export$e45b6700dc30d17;

});

parcelRegister("b0Zp3", function(module, exports) {
/**
 * Default entity ATIs for Jira (1P).
 */ const $0c98a97e7cc3ac07$export$b4a7e1c18385196d = [
    'ati:cloud:jira:project',
    'ati:cloud:jira:issue',
    'ati:cloud:jira:filter',
    'ati:cloud:jira:dashboard',
    'ati:cloud:jira:board',
    'ati:cloud:jira:plan'
];
module.exports["DEFAULT_JIRA_ENTITY_ATI"] = $0c98a97e7cc3ac07$export$b4a7e1c18385196d;

});

parcelRegister("lw0p3", function(module, exports) {
/**
 * Default entity ATIs for Talent/Radar (1P).
 */ const $0d556790a755424e$export$368c06447ee18b39 = [
    'ati:cloud:radar:position'
];
module.exports["DEFAULT_TALENT_ENTITY_ATI"] = $0d556790a755424e$export$368c06447ee18b39;

});

parcelRegister("hPjNv", function(module, exports) {
/**
 * Default entity ATIs for Trello (1P).
 */ const $ed2ed19bcf10c9a7$export$9f88fe41a620c75d = [
    'ati:cloud:trello:board',
    'ati:cloud:trello:card'
];
module.exports["DEFAULT_TRELLO_ENTITY_ATI"] = $ed2ed19bcf10c9a7$export$9f88fe41a620c75d;

});

parcelRegister("A4T5q", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $404bda58dc1ee0db$export$93ca83db1787dea = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip1_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip2_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip1_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip2_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "27.5092",
            height: "26.3",
            fill: "white",
            transform: "translate(6.45831 6.875)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "27.5092",
        height: "26.3",
        fill: "white",
        transform: "translate(6.45831 6.875)"
    }))));
const $404bda58dc1ee0db$export$b0a52366c3fb9b = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip1_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip2_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip1_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip2_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "28.9104",
            height: "28.8583",
            fill: "white",
            transform: "translate(5.83331 3.33337)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "28.9104",
        height: "28.8583",
        fill: "white",
        transform: "translate(5.83331 3.33337)"
    }))));
const $404bda58dc1ee0db$export$1afe31d4b2891d7a = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip1_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip2_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip1_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip2_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "27.2333",
            height: "27.2333",
            fill: "white",
            transform: "translate(6.25 7.08334)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "27.2333",
        height: "27.2333",
        fill: "white",
        transform: "translate(6.25 7.08334)"
    }))));
const $404bda58dc1ee0db$export$7221b4e3b691d1b3 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2230_18718)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip1_2230_18718)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2230_18718"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip1_2230_18718"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $404bda58dc1ee0db$export$4b1b9db11d699ccb = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2230_18698)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip1_2230_18698)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2230_18698"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip1_2230_18698"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $404bda58dc1ee0db$export$4d0238652f4b6bc4 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2230_18694)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip1_2230_18694)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2230_18694"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip1_2230_18694"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $404bda58dc1ee0db$export$24d355ce80de5803 = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            height: "100%",
            viewBox: "0 0 24 24"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fill: "var(--tile-color,#ffc716)",
            d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fill: "var(--icon-color, #101214)",
            fillRule: "evenodd",
            d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
            clipRule: "evenodd"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fill: "var(--icon-color, #101214)",
            d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "var(--tile-color,#ffc716)",
        d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        fillRule: "evenodd",
        d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
    }));
const $404bda58dc1ee0db$export$5427c633f31d110f = (0, $4pOgL.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip0_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip1_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: "url(#clip2_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
            fill: "#FB9700"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
            fill: "#101214"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip0_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white",
            transform: "translate(0 0.101562)"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip1_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white",
            transform: "translate(0 0.101562)"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: "32",
            height: "33",
            viewBox: "0 0 32 33",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: "clip2_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
            fill: "white"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "32",
        height: "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "#FB9700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
        fill: "#101214"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "white"
    }))));
module.exports["ConfluenceSearchResultIcon"] = $404bda58dc1ee0db$export$93ca83db1787dea;
module.exports["AtlasSearchResultIcon"] = $404bda58dc1ee0db$export$b0a52366c3fb9b;
module.exports["JiraProductDiscoverySearchResultIcon"] = $404bda58dc1ee0db$export$1afe31d4b2891d7a;
module.exports["TrelloSearchResultIcon"] = $404bda58dc1ee0db$export$7221b4e3b691d1b3;
module.exports["CompassSearchResultIcon"] = $404bda58dc1ee0db$export$4b1b9db11d699ccb;
module.exports["FocusSearchResultIcon"] = $404bda58dc1ee0db$export$4d0238652f4b6bc4;
module.exports["AssetsSearchResultIcon"] = $404bda58dc1ee0db$export$24d355ce80de5803;
module.exports["TalentSearchResultIcon"] = $404bda58dc1ee0db$export$5427c633f31d110f;

});

parcelRegister("a5RR2", function(module, exports) {

var $fWXSj = parcelRequire("fWXSj");


var $bRTcz = parcelRequire("bRTcz");


var $cBXDq = parcelRequire("cBXDq");


var $9o4in = parcelRequire("9o4in");


var $eS8nS = parcelRequire("eS8nS");


var $eHKKm = parcelRequire("eHKKm");


var $3vavW = parcelRequire("3vavW");


var $3MVdA = parcelRequire("3MVdA");


var $69fjO = parcelRequire("69fjO");


var $jOAlg = parcelRequire("jOAlg");


var $d0ffx = parcelRequire("d0ffx");


var $bfMVn = parcelRequire("bfMVn");


var $1vkrr = parcelRequire("1vkrr");


var $29M8h = parcelRequire("29M8h");


var $7CU5w = parcelRequire("7CU5w");


var $gNXFU = parcelRequire("gNXFU");


var $5rdfZ = parcelRequire("5rdfZ");


var $8ghR9 = parcelRequire("8ghR9");


var $blmQP = parcelRequire("blmQP");


var $2UKvr = parcelRequire("2UKvr");


var $cQLav = parcelRequire("cQLav");


var $lghXu = parcelRequire("lghXu");


var $3ruME = parcelRequire("3ruME");


var $lwrok = parcelRequire("lwrok");


var $hQVy3 = parcelRequire("hQVy3");


var $cnErZ = parcelRequire("cnErZ");


var $hOS5n = parcelRequire("hOS5n");


var $92bi2 = parcelRequire("92bi2");


var $jxSYu = parcelRequire("jxSYu");


var $8c1uN = parcelRequire("8c1uN");


var $dN3MD = parcelRequire("dN3MD");


var $7RXfn = parcelRequire("7RXfn");


var $bbdDG = parcelRequire("bbdDG");


var $k0vWa = parcelRequire("k0vWa");


var $ax3yU = parcelRequire("ax3yU");


var $9pKRO = parcelRequire("9pKRO");


var $cwJDI = parcelRequire("cwJDI");


var $4LVIl = parcelRequire("4LVIl");


var $h9iwl = parcelRequire("h9iwl");


var $5gYzJ = parcelRequire("5gYzJ");


var $du9hX = parcelRequire("du9hX");


var $do3W8 = parcelRequire("do3W8");


var $5Bb9f = parcelRequire("5Bb9f");


var $goA9n = parcelRequire("goA9n");


var $73rhf = parcelRequire("73rhf");


var $1IR6D = parcelRequire("1IR6D");


var $dY2MK = parcelRequire("dY2MK");


var $6IFfo = parcelRequire("6IFfo");


var $86B61 = parcelRequire("86B61");


var $deGo2 = parcelRequire("deGo2");


var $c0GOq = parcelRequire("c0GOq");


var $lVXgC = parcelRequire("lVXgC");


var $il47H = parcelRequire("il47H");


var $6SplI = parcelRequire("6SplI");


var $fibiE = parcelRequire("fibiE");


var $4eIDA = parcelRequire("4eIDA");


var $3Cz7D = parcelRequire("3Cz7D");


var $3TyJ3 = parcelRequire("3TyJ3");


var $djETu = parcelRequire("djETu");


var $4FjHU = parcelRequire("4FjHU");


var $hDzfU = parcelRequire("hDzfU");


var $deCcX = parcelRequire("deCcX");


var $c7moJ = parcelRequire("c7moJ");


var $bllsF = parcelRequire("bllsF");


var $apC1g = parcelRequire("apC1g");


var $5CdDA = parcelRequire("5CdDA");


var $7Ybf0 = parcelRequire("7Ybf0");


var $8QURv = parcelRequire("8QURv");


var $9VfJT = parcelRequire("9VfJT");


var $4tJLm = parcelRequire("4tJLm");


var $eVtI3 = parcelRequire("eVtI3");


var $c2Gh1 = parcelRequire("c2Gh1");


var $59Q0u = parcelRequire("59Q0u");


var $7BCex = parcelRequire("7BCex");


var $cQNOi = parcelRequire("cQNOi");


var $ay3nk = parcelRequire("ay3nk");


var $dTyKo = parcelRequire("dTyKo");


var $7JjDF = parcelRequire("7JjDF");


var $eaaHo = parcelRequire("eaaHo");


var $8Q0vI = parcelRequire("8Q0vI");


var $ixnTR = parcelRequire("ixnTR");


var $1FyJF = parcelRequire("1FyJF");


var $65dnd = parcelRequire("65dnd");


var $iRR2B = parcelRequire("iRR2B");


var $iQ0lV = parcelRequire("iQ0lV");


var $cbOCM = parcelRequire("cbOCM");


var $aWbHl = parcelRequire("aWbHl");


var $h08jq = parcelRequire("h08jq");


var $Wmb4v = parcelRequire("Wmb4v");


var $77dhg = parcelRequire("77dhg");


var $hklt8 = parcelRequire("hklt8");


var $3OpIS = parcelRequire("3OpIS");


var $78z3f = parcelRequire("78z3f");


var $kEEaa = parcelRequire("kEEaa");


var $kuTad = parcelRequire("kuTad");


var $9t8gB = parcelRequire("9t8gB");

const $abd986d1a9638194$export$f26e5f55e570679c = new Map([
    [
        (0, $78z3f.ProductKeys3P).AtlassianWebCrawler,
        (0, $3vavW.atlassianWebCrawlerConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Figma,
        (0, $8ghR9.figmaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Github,
        (0, $c7moJ.githubConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).GoogleDrive,
        (0, $5CdDA.googleDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Sharepoint,
        (0, $aWbHl.sharepointConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Loom,
        (0, $c2Gh1.loomConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).OneDrive,
        (0, $7JjDF.oneDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Dropbox,
        (0, $5rdfZ.dropboxConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Slack,
        (0, $h08jq.slackConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Teams,
        (0, $hklt8.teamsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).GoogleCalendar,
        (0, $7Ybf0.googleCalendarConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Gmail,
        (0, $apC1g.gmailConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).OutlookCalendar,
        (0, $eaaHo.outlookCalendarConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).OutlookMail,
        (0, $8Q0vI.outlookMail)
    ],
    [
        (0, $78z3f.ProductKeys3P).Asana,
        (0, $eHKKm.asanaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Zendesk,
        (0, $kuTad.zendeskConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Airtable,
        (0, $9o4in.airtableConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Smartsheet,
        (0, $Wmb4v.smartsheetConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Notion,
        (0, $dTyKo.notionConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Miro,
        (0, $7BCex.miroConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Docusign,
        (0, $7CU5w.docusignConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Lucid,
        (0, $59Q0u.lucidConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Monday,
        (0, $cQNOi.mondayConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AzureDevops,
        (0, $69fjO.azureDevopsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Gitlab,
        (0, $bllsF.gitlabConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ConfluenceDC,
        (0, $1vkrr.confluenceDCConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).JiraDC,
        (0, $9VfJT.jiraDCConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).JsmDC,
        (0, $4tJLm.jsmDCConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Canva,
        (0, $d0ffx.canvaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Box,
        (0, $jOAlg.boxConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Zeplin,
        (0, $9t8gB.zeplinConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ServiceNow,
        (0, $cbOCM.serviceNowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Freshservice,
        (0, $hDzfU.freshserviceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).PowerBI,
        (0, $65dnd.powerBIConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ClickUp,
        (0, $bfMVn.clickUpConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Amplitude,
        (0, $eS8nS.amplitudeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Stripe,
        (0, $77dhg.stripeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AdobeXD,
        (0, $bRTcz.adobeXDConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Aha,
        (0, $cBXDq.ahaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AdobeSign,
        (0, $fWXSj.adobeSignConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Mural,
        (0, $ay3nk.muralConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Webex,
        (0, $kEEaa.webexConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Todoist,
        (0, $3OpIS.todoistConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).PagerDuty,
        (0, $ixnTR.pagerDutyConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Pipedrive,
        (0, $1FyJF.pipedriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $8QURv.hubSpotConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Dovetail,
        (0, $gNXFU.dovetailConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).LaunchDarkly,
        (0, $eVtI3.launchDarklyConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Salesforce,
        (0, $iRR2B.salesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Sentry,
        (0, $iQ0lV.sentryConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Gitbook,
        (0, $deCcX.gitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AWSS3,
        (0, $3MVdA.awss3Config)
    ],
    [
        (0, $78z3f.ProductKeys3P).Databricks,
        (0, $29M8h.databricksConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $blmQP.forgeAdamVitareqConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $2UKvr.forgeAdamVitareqConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $3ruME.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $lwrok.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioAwsDev,
        (0, $hQVy3.forgePioAwsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioAwsProd,
        (0, $cnErZ.forgePioAwsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioClickupDev,
        (0, $hOS5n.forgePioClickupConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioClickupProd,
        (0, $92bi2.forgePioClickupConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitbookDev,
        (0, $jxSYu.forgePioGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitbookProd,
        (0, $8c1uN.forgePioGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
        (0, $dN3MD.forgePioGithubConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
        (0, $7RXfn.forgePioGithubConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
        (0, $bbdDG.forgePioGitlabConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
        (0, $k0vWa.forgePioGitlabConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $ax3yU.forgePioGoogleDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $9pKRO.forgePioGoogleDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGuruDev,
        (0, $cwJDI.forgePioGuruConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGuruProd,
        (0, $4LVIl.forgePioGuruConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $h9iwl.forgePioHelpjuiceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $5gYzJ.forgePioHelpjuiceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHubspotDev,
        (0, $du9hX.forgePioHubspotConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHubspotProd,
        (0, $do3W8.forgePioHubspotConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceDev,
        (0, $5Bb9f.forgePioSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceProd,
        (0, $goA9n.forgePioSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSharepointDev,
        (0, $73rhf.forgePioSharepointConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSharepointProd,
        (0, $1IR6D.forgePioSharepointConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $dY2MK.forgePioStackOverflowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $6IFfo.forgePioStackOverflowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $djETu.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $4FjHU.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $cQLav.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $lghXu.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $il47H.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $6SplI.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $fibiE.forgeUnitoServicenowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $4eIDA.forgeUnitoServicenowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $3Cz7D.forgeUnitoWrikeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $3TyJ3.forgeUnitoWrikeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $86B61.forgeUnitoAsanaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $deGo2.forgeUnitoAsanaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $c0GOq.forgeUnitoBasecampConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $lVXgC.forgeUnitoBasecampConfig)
    ]
]);
module.exports["ThirdPartyConfigsSync"] = $abd986d1a9638194$export$f26e5f55e570679c;

});

parcelRegister("8yIwZ", function(module, exports) {
/**
 * RAOC-22 — Canonical `useRovoConfig` hook, ported from
 * `@atlassian/search-page/src/controllers/config/index.tsx` (the search-page
 * `useFetchConfig`).
 *
 * This hook is intended to become the canonical way to fetch the combined
 * Rovo search bootstrap config (1P + 3P + nouns + site metadata + linked
 * sites). It is currently being rolled out behind the
 * `rovo_fps_use_rovo_config` feature gate and is **not yet** the supported
 * replacement for the legacy `useFetchConfig` (also exported from this
 * package) — that hook will only be marked `@deprecated` after rollout
 * completes. See RAOC-22.
 *
 * Differences from search-page's `useFetchConfig` body:
 *   - `primaryProduct` is **not** a prop. Primary-product patching (and
 *     `fg('rovo-search-patch-primary-product')`) moves out of the hook and
 *     into search-page as a post-hook transform applied at the call site
 *     (PR-3). Per plan decision #21.
 *   - Analytics are fully internalised: the hook builds its own
 *     `fireAnalyticsEvent` via `useAnalyticsEvents()` from
 *     `@atlaskit/analytics-next` and its own `logException`. No `analytics`
 *     prop is required.
 *   - VitalStats task names are hard-coded at module scope
 *     (`search-page/combined-config-ux` and
 *     `search-page/combined-config-network`) — owned by this
 *     hook, not caller-supplied. Same rationale for `actionSubject` and the
 *     VitalStats event factories themselves (they live in
 *     `../network/network-task-tracker`, not as a prop). The analytics
 *     taxonomy is part of this hook's contract with the dashboards, not
 *     something each caller redefines. Per RAOC-22 open questions Q1
 *     and Q3 (resolved 2026-05-25).
 *   - Optional `shouldBypassPreloadProvider(preloaded)` callback lets the
 *     caller skip the preload provider for specific sources (search-page
 *     passes `isQuickFindAsyncPreloadEnabled() && preloaded?.source ===
 *     'quick-find'`). Per plan decision #5.
 *   - `preloadDataProvider` is typed as the narrow
 *     `RovoConfigPreloadProvider` (see `./combined-config/preload-types.ts`).
 *     Search-page's wider `SearchPreloadDataProvider` satisfies the narrow
 *     shape structurally.
 *   - The combined-config `parseCombinedConfig` post-processing is removed
 *     from this hook: callers that want it should call `parseCombinedConfig`
 *     directly on the returned `combinedConfigResponse`. This keeps the
 *     hook's return shape stable across the `search_async_ssr` cleanup
 *     boundary (post-cleanup shape per plan decision #7).
 *   - `isNounsAvailable` is **not** returned — per plan decision #8.
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $7GE7t = parcelRequire("7GE7t");


var $johDC = parcelRequire("johDC");


var $lT617 = parcelRequire("lT617");


var $eANll = parcelRequire("eANll");


var $dqL0S = parcelRequire("dqL0S");


var $8450i = parcelRequire("8450i");


var $k88qI = parcelRequire("k88qI");


var $1WA3C = parcelRequire("1WA3C");


var $5KLkP = parcelRequire("5KLkP");


var $2ZsZI = parcelRequire("2ZsZI");


var $abNiP = parcelRequire("abNiP");

const $a49fca881bd6f166$var$EMPTY_RESPONSE = [];
/**
 * VitalStats task names emitted by this hook. Owned by `useRovoConfig`
 * (not caller-supplied) — see RAOC-22 open question Q1.
 *
 * TODO RAOC-22 migrate analytics off search-specific naming
 */ const $a49fca881bd6f166$var$TASK_NAME_UX = 'search-page/combined-config-ux';
const $a49fca881bd6f166$var$TASK_NAME_NETWORK = 'search-page/combined-config-network';
// TODO RAOC-22 migrate analytics off search-specific naming
const $a49fca881bd6f166$var$source = 'advancedSearchScreen';
const $a49fca881bd6f166$export$9d26acf0ac0b34e7 = ({ cloudId: cloudIdProp, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, preloadDataProvider: preloadDataProvider, shouldBypassPreloadProvider: shouldBypassPreloadProvider, onForgeConnectorTypeMapping: onForgeConnectorTypeMapping })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: payload.source || $a49fca881bd6f166$var$source,
            attributes: {
                ...payload.attributes?.commonAttributes,
                ...payload.attributes?.additionalAttributes
            }
        }).fire('fabric-elements');
    }, [
        createAnalyticsEvent
    ]);
    const taskNameUx = $a49fca881bd6f166$var$TASK_NAME_UX;
    const taskNameNetwork = $a49fca881bd6f166$var$TASK_NAME_NETWORK;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $42omo.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $42omo.useState)(false);
    const [combinedThirdPartyResponse, setCombinedThirdPartyResponse] = (0, $42omo.useState)({});
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $42omo.useState)(undefined);
    const [combinedConfigResponse, setCombinedConfigResponse] = (0, $42omo.useState)();
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $42omo.useState)({
        nouns: []
    });
    // Keep a live ref to the latest thirdPartyConfigs so the stable
    // `onOAuthSuccess` callback (created once with no React-state deps)
    // can read the current value without going stale across renders.
    const thirdPartyConfigsRef = (0, $42omo.useRef)(accessibleProductsConfig.thirdPartyConfigs);
    thirdPartyConfigsRef.current = accessibleProductsConfig.thirdPartyConfigs;
    const onOAuthSuccess = (0, $42omo.useCallback)(({ product: product, datasourceId: datasourceId })=>{
        const currentConfigs = thirdPartyConfigsRef.current;
        const productConfig = currentConfigs?.[product];
        if (!productConfig) return;
        if (datasourceId !== undefined && !productConfig.datasources?.some((ds)=>ds.datasourceId === datasourceId)) return;
        let nextConfigs = currentConfigs;
        if (datasourceId === undefined) {
            if (productConfig.userNeedsOAuth !== false) nextConfigs = {
                ...currentConfigs,
                [product]: {
                    ...productConfig,
                    userNeedsOAuth: false
                }
            };
        } else {
            const datasources = productConfig.datasources ?? [];
            const targetIdx = datasources.findIndex((ds)=>ds.datasourceId === datasourceId);
            if (targetIdx >= 0 && datasources[targetIdx].userNeedsOAuth !== false) {
                const nextDatasources = datasources.map((ds, i)=>i === targetIdx ? {
                        ...ds,
                        userNeedsOAuth: false
                    } : ds);
                nextConfigs = {
                    ...currentConfigs,
                    [product]: {
                        ...productConfig,
                        datasources: nextDatasources
                    }
                };
            }
        }
        thirdPartyConfigsRef.current = nextConfigs;
        setAccessibleProductsConfig((prev)=>({
                ...prev,
                thirdPartyConfigs: nextConfigs
            }));
        if (cloudIdProp) {
            const thirdPartyTypes = (0, $dqL0S.getThirdPartyTypes)();
            (0, $7GE7t.updateBaseCombinedConfigCacheEntry)(cloudIdProp, (config)=>({
                    ...config,
                    thirdPartyProducts: config.thirdPartyProducts?.map((entry)=>{
                        if (datasourceId) {
                            if (entry.datasourceId === datasourceId) return {
                                ...entry,
                                isUserOAuthed: true
                            };
                        } else if (thirdPartyTypes[entry.name] === product) return {
                            ...entry,
                            isUserOAuthed: true
                        };
                        return entry;
                    })
                }));
        }
    }, [
        cloudIdProp
    ]);
    const firstCloudId = (0, $42omo.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $lT617.getFirstCloudId)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $42omo.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        // `isCancelled` guards against a stale `searchLinkedSitesQuery` promise
        // resolving after the effect has been re-run (e.g. when `cloudIdProp` or
        // `firstCloudId` changes). Without this, a slower in-flight request could
        // overwrite a newer, correct linkedCloudARIs value. Set in the cleanup
        // function returned below and checked before every state update inside
        // `.then()` / `.catch()`.
        let isCancelled = false;
        if (cloudId && multiSiteSearchInRovo) (0, $johDC.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        })// The shape returned by `searchLinkedSitesQuery` is not exported by
        // `@atlassian/search-client/search-page`, so we narrow it locally:
        // it's a GraphQL response keyed by the operation name with an
        // `edges`/`node`/`id` chain. Use `unknown` + a structural cast at the
        // access site instead of `any` so subsequent property access stays
        // type-checked. Long-term fix is to export a type from search-client
        // — tracked alongside the other search-client type-promotion follow-ups
        // in the RAOC-22 work doc.
        .then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            if (isCancelled) return;
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            if (isCancelled) return;
            (0, $5KLkP.logException)(error);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        aggAbsoluteUrl
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!firstPartyResponse) {
            if (!cloudIdProp) return;
            if (combinedThirdPartyResponse.productKeys) return;
            const combinedConfigTTL = 60000; // 1 minute
            const fetchCombinedConfig = ()=>{
                const uxTaskId = crypto.randomUUID();
                const taskStartAt = performance.now();
                const baseUXVitalStatsParams = {
                    taskId: uxTaskId,
                    task: taskNameUx
                };
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $k88qI.onDegradedDependency)({
                        dependency: 'search-combined-config',
                        reason: reason,
                        source: $a49fca881bd6f166$var$source
                    }));
                };
                // NOTE: `CacheAnalyticsCallback` is strictly typed as
                // `(state) => Promise<void>` in `@atlassian/search-client/persist-refresh`,
                // so the `async` keyword is structurally required even though the body
                // is synchronous. (Earlier review feedback suggested dropping `async`
                // — that turns out to be incorrect against the current type.) The
                // long-term fix is to widen `CacheAnalyticsCallback` to also accept
                // `void`, tracked as a search-client-tightening follow-up alongside
                // the other type-promotion items in the RAOC-22 work doc.
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $2ZsZI.onRequestCacheAccess)({
                        requestName: 'search-combined-config',
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: $a49fca881bd6f166$var$source
                    }));
                };
                const configNetworkTaskId = crypto.randomUUID();
                const networkCallbacks = (0, $abNiP.createVitalStatsNetworkCallbacks)(configNetworkTaskId, taskNameNetwork, // `createVitalStatsNetworkCallbacks` types its sink as
                // `(event: unknown) => void` to match the factory return
                // shape; our caller sink is typed `(event: FireAnalyticsEvent) => void`.
                // Adapt at the call site — narrow cast is safe because the
                // values come from `onTaskStart` / `onTaskSuccess` / `onTaskFail`
                // in `../network/network-task-tracker`, owned by this package.
                (event)=>fireAnalyticsEvent(event), taskStartAt, {
                    uxTaskId: uxTaskId
                });
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: combinedConfigTTL,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks
                };
                fireAnalyticsEvent((0, $abNiP.onTaskStart)(baseUXVitalStatsParams));
                (0, $7GE7t.getCombinedSearchConfig)(searchConfigParams).then((configuration)=>{
                    setCombinedConfigResponse(configuration);
                    // RAOC: fill the AAID-scoped SSR cache key so the next
                    // server-side render can hydrate `window.__PRELOADED_SEARCH__`.
                    // The hook no longer receives a `userId` prop, so the account
                    // id is resolved asynchronously via `/gateway/api/me` (owned by
                    // this package) and passed to `fillSsrCombinedConfigCache`.
                    if (cloudIdProp) (0, $8450i.fetchCurrentUserAccountId)().then((accountId)=>(0, $7GE7t.fillSsrCombinedConfigCache)({
                            accountId: accountId,
                            cloudId: cloudIdProp,
                            config: configuration,
                            expiration: combinedConfigTTL
                        })).catch((fillError)=>{
                        (0, $5KLkP.logException)(fillError);
                    });
                    const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $eANll.adaptCombinedConfigToLegacy)(configuration, cloudIdProp);
                    setFirstPartyResponse(firstPartyConfig);
                    setCombinedThirdPartyResponse((0, $dqL0S.map3pResourcesToProductKeys)(thirdPartyConfig, onForgeConnectorTypeMapping));
                    fireAnalyticsEvent((0, $abNiP.onTaskSuccess)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                }).catch((error)=>{
                    (0, $5KLkP.logException)(error);
                    fireAnalyticsEvent((0, $1WA3C.onFailedDependency)({
                        dependency: 'search-combined-config',
                        source: $a49fca881bd6f166$var$source
                    }));
                    fireAnalyticsEvent((0, $abNiP.onTaskFail)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: '',
                        siteMetadata: []
                    });
                    setCombinedThirdPartyResponse({
                        productKeys: $a49fca881bd6f166$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                });
            };
            // Read the preload provider at most once per effect run. A stateful
            // provider (e.g. one that clears the entry on first access) would
            // otherwise return null on the second read. Per plan decision #5,
            // `shouldBypassPreloadProvider` receives the cached value below.
            let cachedPreloadedSearch = null;
            let hasReadPreload = false;
            const readPreloadedSearch = ()=>{
                if (!hasReadPreload) {
                    hasReadPreload = true;
                    try {
                        cachedPreloadedSearch = preloadDataProvider?.getPreloadedSearch({
                            cloudId: cloudIdProp
                        }) ?? null;
                    } catch  {
                        // Reading the preload provider must never throw — be defensive.
                        cachedPreloadedSearch = null;
                    }
                }
                return cachedPreloadedSearch;
            };
            // Optional bypass — see plan decision #5
            let shouldBypass = false;
            if (shouldBypassPreloadProvider) shouldBypass = shouldBypassPreloadProvider(readPreloadedSearch());
            if (preloadDataProvider && !shouldBypass) {
                try {
                    const preloadedSearch = readPreloadedSearch();
                    if (preloadedSearch && preloadedSearch.config) {
                        const preloadUxTaskId = crypto.randomUUID();
                        const preloadTaskStartAt = performance.now();
                        const preloadMoreContext = {
                            isSSREvent: true,
                            isConfigFromCache: Boolean(preloadedSearch.isConfigFromCache)
                        };
                        const preloadBaseUXVitalStatsParams = {
                            taskId: preloadUxTaskId,
                            task: taskNameUx,
                            moreContext: preloadMoreContext
                        };
                        fireAnalyticsEvent((0, $abNiP.onTaskStart)(preloadBaseUXVitalStatsParams));
                        try {
                            setCombinedConfigResponse(preloadedSearch.config);
                            const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $eANll.adaptCombinedConfigToLegacy)(preloadedSearch.config, cloudIdProp);
                            setFirstPartyResponse(firstPartyConfig);
                            setCombinedThirdPartyResponse((0, $dqL0S.map3pResourcesToProductKeys)(thirdPartyConfig, onForgeConnectorTypeMapping));
                            const preloadedConfig = preloadedSearch.config;
                            if (!preloadedSearch.isConfigFromCache && preloadedConfig && cloudIdProp) {
                                (0, $7GE7t.seedBaseCombinedConfigCacheEntry)({
                                    cloudId: cloudIdProp,
                                    config: preloadedConfig,
                                    expiration: combinedConfigTTL
                                }).catch((seedError)=>{
                                    (0, $5KLkP.logException)(seedError);
                                });
                                // RAOC: also fill the AAID-scoped SSR key (resolving the
                                // account id via `/gateway/api/me`) so the next SSR stays
                                // warm. Best-effort; see the network branch for rationale.
                                (0, $8450i.fetchCurrentUserAccountId)().then((accountId)=>(0, $7GE7t.fillSsrCombinedConfigCache)({
                                        accountId: accountId,
                                        cloudId: cloudIdProp,
                                        config: preloadedConfig,
                                        expiration: combinedConfigTTL
                                    })).catch((fillError)=>{
                                    (0, $5KLkP.logException)(fillError);
                                });
                            }
                            fireAnalyticsEvent((0, $abNiP.onTaskSuccess)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            if (preloadedSearch.isConfigFromCache) fetchCombinedConfig();
                            return;
                        } catch (error) {
                            (0, $5KLkP.logException)(error);
                            fireAnalyticsEvent((0, $abNiP.onTaskFail)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    error: error instanceof Error ? error.name : 'unknown',
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            fetchCombinedConfig();
                            return;
                        }
                    }
                    if (preloadedSearch && !preloadedSearch.config) fireAnalyticsEvent((0, $1WA3C.onFailedDependency)({
                        dependency: 'search-config-ssr',
                        source: $a49fca881bd6f166$var$source,
                        moreContext: {
                            cacheFailReason: preloadedSearch.cacheFailReason ?? 'none',
                            configFailReason: preloadedSearch.configFailReason ?? 'none',
                            preloadPayloadWithoutConfig: true
                        }
                    }));
                    fetchCombinedConfig();
                } catch (error) {
                    (0, $5KLkP.logException)(error);
                    fetchCombinedConfig();
                }
                return;
            }
            fetchCombinedConfig();
        }
    }, [
        firstPartyResponse,
        combinedThirdPartyResponse.productKeys,
        cloudIdProp,
        aggAbsoluteUrl,
        fireAnalyticsEvent,
        preloadDataProvider,
        shouldBypassPreloadProvider,
        taskNameUx,
        taskNameNetwork,
        onForgeConnectorTypeMapping
    ]);
    (0, $42omo.useEffect)(()=>{
        if (combinedThirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            const allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match((0, $lT617.EXTRACT_PRODUCT_FROM_ARI));
                    if (match && match.length >= 2 && match[1]) return [
                        match[1]
                    ];
                    return [];
                }))
            ];
            allAccessibleProducts.push(...firstPartyProducts);
            const accessibleNouns = firstPartyResponse.resources.flatMap((resource)=>{
                const { id: id } = resource;
                const match = id.match((0, $lT617.EXTRACT_PRODUCT_FROM_ARI));
                if (match && match.length >= 2 && (match[1] === 'project' || match[1] === 'goal')) return [
                    match[1]
                ];
                return [];
            });
            // If nouns are available we also add Townsquare to the list of accessible products.
            // NOTE (RAOC-22 review): The threshold here (`> 0`) intentionally
            // differs from `parseCombinedConfig.getAccessibleProducts` in
            // `services/combined-config/parse.ts`, which uses `> 1`. This drift is
            // inherited verbatim from search-page (`controllers/config/index.tsx`
            // uses `> 0`, `controllers/config/utils/parse-combined-config.ts` uses
            // `> 1`). RAOC-22 deliberately keeps both as-is so the equivalence test
            // stays honest; reconciling the two thresholds is a search-page
            // behaviour bug-fix that should land in its own PR.
            if (accessibleNouns.length > 0) allAccessibleProducts.push('townsquare');
            const doesUserHaveRovo = (0, $lT617.isRovoEnabledForSite)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = combinedThirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: combinedThirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `setAccessibleProductsConfig`
    // is a useState setter with a stable identity guaranteed by React; including it in the
    // dep array would be misleading. The fields that genuinely drive this effect are the
    // three values below.
    }, [
        combinedThirdPartyResponse,
        firstPartyResponse,
        cloudIdProp,
        accessibleProductsConfig.products
    ]);
    const accessibleProducts = accessibleProductsConfig.products;
    const isRovoEnabled = (0, $lT617.isRovoEnabledForSite)(firstPartyResponse, cloudIdProp);
    const isJiraIssueIndexed = (0, $lT617.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp);
    const productEdition = (0, $lT617.getProductEdition)(firstPartyResponse, cloudIdProp);
    const productDataRegions = (0, $lT617.getProductDataRegions)(firstPartyResponse, cloudIdProp);
    const rovoFeatures = (0, $lT617.getRovoFeatures)(firstPartyResponse, cloudIdProp);
    return (0, $42omo.useMemo)(()=>{
        return {
            accessibleProducts: accessibleProducts,
            accessibleNouns: accessibleProductsConfig.nouns,
            thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
            firstCloudId: firstCloudId,
            intercomHmac: firstPartyResponse?.intercomHmac,
            isRovoEnabled: isRovoEnabled,
            isJiraIssueIndexed: isJiraIssueIndexed,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            rovoFeatures: rovoFeatures,
            isConfigLoaded: isConfigLoaded,
            linkedCloudARIs: linkedCloudARIs,
            combinedConfigResponse: // TODO RAOC-22 clean up when removing FG('rovo_fps_use_rovo_config') and the search-page `useFetchConfig` fallback logic that relies on this field being present in the return type as this will no longer be used
            combinedConfigResponse,
            onOAuthSuccess: onOAuthSuccess
        };
    }, [
        accessibleProducts,
        accessibleProductsConfig.nouns,
        accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId,
        firstPartyResponse?.intercomHmac,
        isRovoEnabled,
        isJiraIssueIndexed,
        productEdition,
        productDataRegions,
        rovoFeatures,
        isConfigLoaded,
        linkedCloudARIs,
        combinedConfigResponse,
        onOAuthSuccess
    ]);
};
module.exports["useRovoConfig"] = $a49fca881bd6f166$export$9d26acf0ac0b34e7;

});

parcelRegister("lT617", function(module, exports) {
/**
 * Internal regex used to extract a cloudId from a Resource ARI of the form:
 *   ari:cloud:<product>::<resourceType>/<cloudId>
 * Capture group 1 yields the cloudId.
 *
 * Public via `getFirstCloudId(...)` and is not exported directly.
 */ const $1007a47236e8b63a$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $1007a47236e8b63a$export$cd4718f771339207 = /ari:cloud:(.*)::/;
const $1007a47236e8b63a$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($1007a47236e8b63a$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $1007a47236e8b63a$export$e9de73272abc8489 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
const $1007a47236e8b63a$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
const $1007a47236e8b63a$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
const $1007a47236e8b63a$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
const $1007a47236e8b63a$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};
module.exports["EXTRACT_PRODUCT_FROM_ARI"] = $1007a47236e8b63a$export$cd4718f771339207;
module.exports["getFirstCloudId"] = $1007a47236e8b63a$export$c1871fdf674a03c4;
module.exports["isRovoEnabledForSite"] = $1007a47236e8b63a$export$e9de73272abc8489;
module.exports["getJiraIssueIndexedForTenant"] = $1007a47236e8b63a$export$37c9c6a3ae5f363c;
module.exports["getProductEdition"] = $1007a47236e8b63a$export$53e066a63a960439;
module.exports["getProductDataRegions"] = $1007a47236e8b63a$export$c635d3296555e2da;
module.exports["getRovoFeatures"] = $1007a47236e8b63a$export$2a1c0662041ee0a3;

});

parcelRegister("eANll", function(module, exports) {
/**
 * RAOC-22 PR-2 — Copied verbatim from
 * `@atlassian/search-page/src/controllers/config/combined-config-adapter.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * Adapts the combined-config response shape to the legacy 1P/3P shape that
 * downstream consumers (third-party-products parser, site-metadata helpers)
 * still operate on. Long-term these consumers should be re-written to read
 * the combined-config shape directly (see TODO QS-9614 in search-page).
 */ const $01396e4e19ec0619$var$mapProductInfoToDataRegions = (productInfo)=>{
    if (!productInfo || productInfo.length === 0) return undefined;
    return productInfo.reduce((acc, info)=>{
        if (!info?.name || !info.dataRegion) return acc;
        acc[info.name] = Array.isArray(info.dataRegion) ? info.dataRegion : [
            info.dataRegion
        ];
        return acc;
    }, {});
};
const $01396e4e19ec0619$var$mapProductEdition = (productEdition, firstPartyProducts)=>{
    if (!productEdition || !firstPartyProducts || firstPartyProducts.length === 0) return undefined;
    return firstPartyProducts.reduce((acc, product)=>{
        acc[product.name] = productEdition;
        return acc;
    }, {});
};
const $01396e4e19ec0619$var$mapSiteMetadata = (siteMetadata, cloudId, firstPartyProducts)=>{
    if (!siteMetadata) return [];
    return [
        {
            siteId: cloudId || '',
            siteName: siteMetadata.siteName || '',
            isNounsAvailable: false,
            // field removed from aggregator; kept to satisfy TSiteMetadata type contract in search-client
            isRovoEnabled: siteMetadata.isRovoEnabled ?? false,
            isJiraIssueIndexed: siteMetadata.isJiraIssueIndexed ?? false,
            productEdition: $01396e4e19ec0619$var$mapProductEdition(siteMetadata.productEdition, firstPartyProducts),
            productDataRegions: $01396e4e19ec0619$var$mapProductInfoToDataRegions(siteMetadata.productInfo),
            rovoFeatures: undefined
        }
    ];
};
const $01396e4e19ec0619$var$mapFirstPartyProductsToResources = (firstPartyProducts, cloudId, siteName)=>{
    return firstPartyProducts.map((product)=>({
            id: `ari:cloud:${product.name}::site/${cloudId || ''}`,
            baseUrl: '',
            siteName: siteName || ''
        }));
};
const $01396e4e19ec0619$var$mapThirdPartyProductsToResources = (thirdPartyProducts)=>{
    return thirdPartyProducts.map((product)=>({
            type: product.name,
            outboundAuthUrl: product.outboundAuthUrl || '',
            isUserOAuthed: product.isUserOAuthed,
            providerId: product.providerId || '',
            connectionId: product.connectionId ?? undefined,
            isImpersonationAuthEnabled: product.isImpersonationAuthEnabled ?? undefined,
            // `product.integrationARI` arrives as `string | null` from the
            // aggregator; `T3pResource['integrationId']` is the branded
            // `PlatformIntegrationAri` nominal type. The value is already an
            // ARI string at this point (it originates server-side from the
            // platform integration registry), so this is structurally safe —
            // the cast only exists to satisfy the brand. Single-step casts
            // (`as PlatformIntegrationAri`) don't work because TS rejects
            // `string`-to-branded direct assignment; the `unknown` hop is the
            // idiomatic workaround. Same pattern is used in
            // `third-party-products.ts`. RAOC-22 follow-up: tighten in
            // search-client by exposing a constructor for branded ARIs.
            integrationId: product.integrationARI ? product.integrationARI : undefined,
            workspaceName: product.workspaceName ?? undefined,
            workspaceUrl: product.workspaceUrl ?? undefined,
            datasourceId: product.datasourceId ?? undefined,
            connectorSyncType: product.connectorSyncType ?? undefined,
            connectorCreatedAt: product.connectorCreatedAt ?? undefined,
            connectedAt: product.connectedAt ?? undefined,
            lightIcon: product.lightIcon ?? undefined,
            entityTypes: product.entityTypes ?? undefined,
            environmentType: product.environmentType ?? undefined
        }));
};
const $01396e4e19ec0619$export$160fbca21b53d78a = (configuration, cloudId)=>{
    const firstPartyProducts = configuration.firstPartyProducts || [];
    const thirdPartyProducts = configuration.thirdPartyProducts || [];
    const siteMetadata = configuration.siteMetadata;
    return {
        firstPartyConfig: {
            resources: $01396e4e19ec0619$var$mapFirstPartyProductsToResources(firstPartyProducts, cloudId, siteMetadata?.siteName || ''),
            intercomHmac: configuration.intercomHmac || '',
            siteMetadata: $01396e4e19ec0619$var$mapSiteMetadata(siteMetadata, cloudId, firstPartyProducts)
        },
        thirdPartyConfig: $01396e4e19ec0619$var$mapThirdPartyProductsToResources(thirdPartyProducts)
    };
};
module.exports["adaptCombinedConfigToLegacy"] = $01396e4e19ec0619$export$160fbca21b53d78a;

});

parcelRegister("dqL0S", function(module, exports) {
/**
 * RAOC-22 PR-2 — Copied from
 * `@atlassian/search-page/src/controllers/config/utils/third-party-products.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * Brings the following feature gates with it (all registered in this package's
 * `platform-feature-flags` map; cleanup tracked in their respective FFCLEANUP
 * tickets — see RAOC-22 plan FG inventory):
 *   - `rovo-search-dynamic-forge-config` (FFCLEANUP-94074)
 *   - `ai_3p_slack_connector_status_transition_enabled` (no FFCLEANUP yet)
 *   - `ai3p_webcrawler_multi_domain_support` (FFCLEANUP-96797)
 */ 
var $dh538 = parcelRequire("dh538");


var $khsIl = parcelRequire("khsIl");


var $a5RR2 = parcelRequire("a5RR2");


var $20IWy = parcelRequire("20IWy");


var $7JSTC = parcelRequire("7JSTC");

const $f88eb491abd480ca$export$6750011b01164bda = ()=>{
    // old sharepoint product key is put here (kept for backwards compatibility), as the new one is in the config
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': `sharepoint`,
        'ai-3p-connector:google-workspace': `drive`
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        'lite-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive-rsl': `drive`,
        'smartlinks-connector-salesforce': `salesforce`,
        'smartlinks-connector-airtable': `airtable`,
        'smartlinks-connector-figma': `figma`,
        'smartlinks-connector-gitlab': `gitlab`,
        'smartlinks-connector-miro': `miro`,
        'smartlinks-connector-asana': `asana`,
        'smartlinks-connector-smartsheet': `smartsheet`,
        'smartlinks-connector-dropbox': `dropbox`,
        'smartlinks-connector-box': `box`,
        'smartlinks-connector-lucid': `lucid`,
        'smartlinks-connector-hubspot': `hubspot`,
        'smartlinks-connector-docusign': `docusign`,
        'smartlinks-connector-slack': `slack`,
        'smartlinks-connector-teams': `teams`,
        'smartlinks-connector-azure-devops': `azure-devops`,
        'smartlinks-connector-notion': `notion`,
        'smartlinks-connector-onedrive': `onedrive`,
        'smartlinks-connector-sharepoint': `sharepoint`
    };
    (0, $a5RR2.ThirdPartyConfigsSync).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
const $f88eb491abd480ca$export$4cb8ef4a677c563c = (resources, onForgeConnectorTypeMapping)=>{
    const THIRD_PARTY_TYPES = $f88eb491abd480ca$export$6750011b01164bda();
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    resources.forEach((resource)=>{
        if ((0, $khsIl.isForgeConnectorProductKey)(resource.type) && (0, $dh538.fg)('rovo-search-dynamic-forge-config')) {
            const config = (0, $7JSTC.mapForgeConnectorToThirdPartyConfig)(resource, onForgeConnectorTypeMapping);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            return;
        }
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) return;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        // NOTE: `productKey` is pushed unconditionally, BEFORE the `if (staticConfig)` guard
        // below. This means a connector type present in `THIRD_PARTY_TYPES` but absent from
        // `ThirdPartyConfigsSync` will appear in the returned `productKeys` without a
        // corresponding entry in `thirdPartyConfigs`. Downstream consumers must therefore
        // treat `thirdPartyConfigs[productKey]` as possibly-undefined for keys that exist in
        // `productKeys`. This is the verbatim search-page behaviour — changing the ordering
        // here would alter the analytics/contract surface and break the search-page
        // equivalence test. RAOC-22 follow-up: reconcile in a behaviour-fix PR after PR-4.
        productKeys.push(productKey);
        let config = {};
        const staticConfig = (0, $a5RR2.ThirdPartyConfigsSync).get(productKey);
        if (staticConfig) {
            const isSlackConnectorSyncTypeEnabled = productKey === 'slack' && (0, $dh538.fg)('ai_3p_slack_connector_status_transition_enabled');
            let sourceType;
            if (resource.type.startsWith((0, $khsIl.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $khsIl.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $khsIl.LITE_CONNECTOR_SOURCE))) sourceType = (0, $khsIl.LITE_CONNECTOR_SOURCE);
            else if (isSlackConnectorSyncTypeEnabled) sourceType = resource.connectorSyncType === 'federated' ? (0, $khsIl.FEDERATED_CONNECTOR_SOURCE) : (0, $khsIl.FULL_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $khsIl.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $khsIl.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $khsIl.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                connectorCreatedAt: resource.connectorCreatedAt ?? undefined,
                connectedAt: resource.connectedAt ?? undefined
            };
            const datasourceList = [];
            const { datasources: _datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                userNeedsOAuth: !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// Renamed to avoid shadowing the outer `_datasources` / `configWithoutDatasources`
            // destructuring above (introduced when removing the eslint-disable in the same
            // review round).
            ({ datasources: _d, ...cleanedEntry })=>cleanedEntry);
            datasourceList.push(...cleanedExtraDatasources);
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    });
    // Filter product keys to only include valid ones.
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $khsIl.isForgeConnectorProductKey)(productKey)) return true;
        return (0, $20IWy.allProductKeys).includes(productKey);
    });
    const deduplicatedProductKeys = [
        ...new Set(filteredProductKeys)
    ];
    return {
        productKeys: deduplicatedProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};
module.exports["getThirdPartyTypes"] = $f88eb491abd480ca$export$6750011b01164bda;
module.exports["map3pResourcesToProductKeys"] = $f88eb491abd480ca$export$4cb8ef4a677c563c;

});

parcelRegister("8450i", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");

/**
 * RAOC: account-id resolution for the combined-config SSR cache fill.
 *
 * `useRovoConfig` no longer receives a `userId` prop. The only remaining need
 * for the Atlassian Account ID (AAID) is to write the SSR localStorage cache
 * entry under the AAID-based inner hash that the Confluence SSR preloader
 * (`@confluence/search-route-preloader` → `preloadSearch.ts`) reads back.
 *
 * This module resolves the current user's AAID via a local lookup of
 * `/gateway/api/me`, mirroring the existing pattern in
 * `@confluence/error-app` (`fetchGet('/gateway/api/me') → account_id`).
 *
 * It lives in `rovo-connectors-config` (the orchestrator of the SSR-fill)
 * rather than `search-client`, so the network call is owned by the package
 * that decides when to fill the cache; `search-client` only owns the cache
 * key shape.
 *
 * The result is memoised for the lifetime of the page: the AAID does not
 * change within a session, and the SSR-fill may run on multiple config
 * resolutions, so we fetch at most once.
 */ const $3329bbe0d31bc411$var$RELATIVE_URL_ME = '/gateway/api/me';
/**
 * In-memory, page-lifetime memo of the in-flight (or resolved) `/me` request.
 * Reset only by a full page load. Stores the promise (not just the value) so
 * concurrent callers share a single network request.
 */ let $3329bbe0d31bc411$var$currentUserAccountIdPromise;
const $3329bbe0d31bc411$var$requestCurrentUserAccountId = async ()=>{
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    try {
        const response = await (0, $dwp40.utils).requestService({
            url: $3329bbe0d31bc411$var$RELATIVE_URL_ME
        }, options);
        return response?.account_id ?? null;
    } catch  {
        // Best-effort: a failed /me lookup only degrades the SSR warm path
        // (the next SSR falls back to a network preload). Never throw.
        return null;
    }
};
const $3329bbe0d31bc411$export$35d4e28a86099a2d = async ()=>{
    // SSR guard — the fill only ever runs in the browser.
    if (typeof window === 'undefined') return null;
    if (!$3329bbe0d31bc411$var$currentUserAccountIdPromise) $3329bbe0d31bc411$var$currentUserAccountIdPromise = $3329bbe0d31bc411$var$requestCurrentUserAccountId().then((accountId)=>{
        // Do not memoise a null result: allow a later retry to succeed
        // (e.g. transient /me failure during early page load).
        if (accountId == null) $3329bbe0d31bc411$var$currentUserAccountIdPromise = undefined;
        return accountId;
    });
    return $3329bbe0d31bc411$var$currentUserAccountIdPromise;
};
const $3329bbe0d31bc411$export$a4689f8cac12fef8 = ()=>{
    $3329bbe0d31bc411$var$currentUserAccountIdPromise = undefined;
};
module.exports["fetchCurrentUserAccountId"] = $3329bbe0d31bc411$export$35d4e28a86099a2d;

});

parcelRegister("k88qI", function(module, exports) {
/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 *
 * Not exported via a package subpath — consumers should not import this
 * directly; the canonical way to fire a degraded-dependency event is by
 * passing analytics callbacks into the hook.
 *
 * NOTE: `FireAnalyticsEvent` is intentionally not imported from search-page
 * to avoid a cross-package cycle. We type the return value structurally to
 * match the search-page shape — search-page's `FireAnalyticsEvent` and ours
 * are compatible at the structural level (both extend `GasPayload &
 * AnalyticsAttributes`).
 */ const $15fe6a6d591ac8b5$export$e98932ab9e22c265 = ({ dependency: dependency, reason: reason, source: source })=>{
    return {
        source: source,
        action: 'degradedDependency',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason
            }
        }
    };
};
module.exports["onDegradedDependency"] = $15fe6a6d591ac8b5$export$e98932ab9e22c265;

});

parcelRegister("1WA3C", function(module, exports) {
/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */ const $b55b557730df2396$export$7199f2d13e6ae9f7 = ({ dependency: dependency, source: source, moreContext: moreContext })=>{
    return {
        source: source,
        action: 'failedDependency',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                ...moreContext || {}
            }
        }
    };
};
module.exports["onFailedDependency"] = $b55b557730df2396$export$7199f2d13e6ae9f7;

});

parcelRegister("5KLkP", function(module, exports) {

var $4JgC8 = parcelRequire("4JgC8");


var $bXE8w = parcelRequire("bXE8w");

const $1532356a07244182$export$f86b2a1a2ce291b3 = async (error)=>{
    try {
        const SentryClient = await (0, $bXE8w.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            for (const [key, value] of Object.entries((0, $4JgC8.COMMON_TAGS)))scope.setTag(key, value);
            SentryClient.captureException(error, scope);
        });
    } catch (sentryError) {
        // When there was an error with Sentry, just output to console.
        // eslint-disable-next-line no-console
        console.error(sentryError);
    }
};
module.exports["logException"] = $1532356a07244182$export$f86b2a1a2ce291b3;

});

parcelRegister("4JgC8", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/search-page/getting-started
const $ffd07bcdf31e3a99$export$6faa4a850bc4d0ce = 'https://dcf49f8a57e71c9e77d30808a7708f8c@o55978.ingest.us.sentry.io/4506951588773888';
const $ffd07bcdf31e3a99$export$ea77880e3935182d = 'unknown';
const $ffd07bcdf31e3a99$export$d60e93659f587f71 = {
    search: true // Used to filter out errors that are not from search projects
};
module.exports["SENTRY_DSN"] = $ffd07bcdf31e3a99$export$6faa4a850bc4d0ce;
module.exports["UNKNOWN_TAG"] = $ffd07bcdf31e3a99$export$ea77880e3935182d;
module.exports["COMMON_TAGS"] = $ffd07bcdf31e3a99$export$d60e93659f587f71;

});

parcelRegister("bXE8w", function(module, exports) {

var $5QinP = parcelRequire("5QinP");


var $joFH5 = parcelRequire("joFH5");


var $4JgC8 = parcelRequire("4JgC8");

let $d7518b5a9314f4be$var$Sentry;
const $d7518b5a9314f4be$var$beforeSend = (event)=>{
    if (event.environment === 'development') return null;
    // Ignore errors that do not come from search projects
    if (!event.tags?.search) return null;
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    return event;
};

const $d7518b5a9314f4be$export$f553e8b08ef59d31 = async ()=>{
    if (!$d7518b5a9314f4be$var$Sentry) {
        if ((0, $joFH5.getEnvironment)() === 'development') return;
        $d7518b5a9314f4be$var$Sentry = Promise.resolve((parcelRequire("7hGsm"))).then((SentryModule)=>{
            SentryModule.init({
                dsn: (0, $4JgC8.SENTRY_DSN),
                attachStacktrace: true,
                release: (0, $5QinP.PRODUCT_BUILD) || (0, $4JgC8.UNKNOWN_TAG),
                environment: (0, $joFH5.getEnvironment)(),
                beforeSend: $d7518b5a9314f4be$var$beforeSend
            });
            return SentryModule;
        }).catch(()=>{
        // TODO: Retry mechanism for chunk loading failures?
        });
    }
    return $d7518b5a9314f4be$var$Sentry;
};
module.exports["getSentryClient"] = $d7518b5a9314f4be$export$f553e8b08ef59d31;

});

parcelRegister("5QinP", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ // @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */ const $eb9263707673332f$export$668f31ea3127f48f = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;
module.exports["PRODUCT_BUILD"] = $eb9263707673332f$export$668f31ea3127f48f;

});

parcelRegister("joFH5", function(module, exports) {
const $c8f5d06fde7473a8$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $c8f5d06fde7473a8$export$57570b1603cf6adb;

});

parcelRegister("2ZsZI", function(module, exports) {
/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */ const $426478a9d042ad10$export$786813d6840571a0 = ({ requestName: requestName, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered
            }
        }
    };
};
module.exports["onRequestCacheAccess"] = $426478a9d042ad10$export$786813d6840571a0;

});

parcelRegister("abNiP", function(module, exports) {
/**
 * RAOC-22 PR-2 — Copied from
 * `@atlassian/search-page/src/common/utils/network-task-tracker.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * The `task-names`/`vital-stats-events` modules referenced by the search-page
 * version live in search-page. To keep this helper self-contained inside
 * rovo-connectors-config (and free of cross-package cycles), we type the
 * task name as a plain `string` and accept the vital-stats event factories
 * (`onTaskStart` / `onTaskSuccess` / `onTaskFail`) implicitly via the
 * provided `fireAnalyticsEvent` callback — the caller in search-page builds
 * the events at the call site.
 *
 * Brings `fg('rovo-search-vitalstats-tracing-headers')`, registered in this
 * package's `platform-feature-flags` map.
 */ 
var $dh538 = parcelRequire("dh538");


var $6jKOp = parcelRequire("6jKOp");

/**
 * VitalStats event factories owned by this module. The vital-stats event wire
 * shape is part of the `useRovoConfig` contract with the VitalStats taxonomy,
 * not something each caller redefines — owning them here keeps every consumer
 * emitting the same shape and prevents drift between dashboards. Behaviour is
 * identical to search-page's `onTaskStart` / `onTaskSuccess` / `onTaskFail`
 * from `common/utils/events/vital-stats-events.ts`.
 */ const $3d47f3232aaf0423$var$buildVitalStatsEvent = (action, { taskId: taskId, task: task, moreContext: moreContext })=>({
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: typeof window !== 'undefined' ? window.location.hostname : '',
                ...moreContext
            }
        }
    });
const $3d47f3232aaf0423$export$656fa717a09eb821 = (args)=>$3d47f3232aaf0423$var$buildVitalStatsEvent('taskStart', args);
const $3d47f3232aaf0423$export$3e9761d670712e50 = (args)=>$3d47f3232aaf0423$var$buildVitalStatsEvent('taskSuccess', args);
const $3d47f3232aaf0423$export$2e311f5a2c70a936 = (args)=>$3d47f3232aaf0423$var$buildVitalStatsEvent('taskFail', args);
const $3d47f3232aaf0423$export$b551db3ea2671aa7 = (taskId, taskName, fireAnalyticsEvent, configNetworkTaskStartAt, context)=>{
    const baseParams = {
        taskId: taskId,
        task: taskName
    };
    return {
        onStart: ()=>{
            fireAnalyticsEvent($3d47f3232aaf0423$export$656fa717a09eb821({
                ...baseParams,
                moreContext: context
            }));
        },
        onSuccess: (traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent($3d47f3232aaf0423$export$3e9761d670712e50({
                ...baseParams,
                moreContext: {
                    ...context,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        },
        onError: (errorName, errorMessage, traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $dh538.fg)('rovo-search-vitalstats-tracing-headers') ? (0, $6jKOp.normaliseTraceInfo)(traceInfo) : {};
            fireAnalyticsEvent($3d47f3232aaf0423$export$2e311f5a2c70a936({
                ...baseParams,
                moreContext: {
                    ...context,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        }
    };
};
module.exports["onTaskStart"] = $3d47f3232aaf0423$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $3d47f3232aaf0423$export$3e9761d670712e50;
module.exports["onTaskFail"] = $3d47f3232aaf0423$export$2e311f5a2c70a936;
module.exports["createVitalStatsNetworkCallbacks"] = $3d47f3232aaf0423$export$b551db3ea2671aa7;

});


//# sourceMappingURL=RovoLinkPickerAdapter.8f49fd16.js.map
